import { Component, Input, Output } from 'angular-ts-decorators';

import { IProductOrder } from '../models/product-order';

interface IOnOrderChangeFnArgs {
  order: IProductOrder;
}

type IOnOrderChangeFn = (args: IOnOrderChangeFnArgs) => void;

import template from './product-orders.component.html';

@Component({
  selector: 'productOrders',
  template,
})
export class ProductOrdersComponent {
  public static $inect: ReadonlyArray<string> = [];

  @Output() public onOrderChange: IOnOrderChangeFn;
  @Input() public orders: IProductOrder[];
  @Input() public selectedOrder: IProductOrder;

  public showOrders = false;

  public overlayClicked() {
    this.showOrders = false;
  }

  public toggleOrders() {
    this.showOrders = !this.showOrders;
  }

  public orderChanged(order: IProductOrder) {
    this.showOrders = false;
    if (this.onOrderChange) {
      this.onOrderChange({ order });
    }
  }
}
